
export default function ServicesSection() {
  const services = [
    {
      title: 'Therapeutic Massage',
      description: 'Deep tissue and Swedish massage techniques to relieve muscle tension, improve circulation, and promote overall relaxation and healing.',
      icon: 'ri-hand-heart-line',
      image: 'https://public.readdy.ai/ai/img_res/3f9bc3254fbcc09544846a568911608c.jpg'
    },
    {
      title: 'Chinese Medicine',
      description: 'Traditional Chinese medicine practices including herbal remedies, cupping therapy, and holistic treatments for balanced health and vitality.',
      icon: 'ri-leaf-line',
      image: 'https://readdy.ai/api/search-image?query=traditional-chinese-medicine-treatment-cupping-therapy-herbal-remedies-acupuncture-tools-natural-healing-elements-bamboo-zen-stones-peaceful-wellness-setting-holistic-health-practice&width=600&height=400&seq=service-chinese-med-2&orientation=landscape'
    },
    {
      title: 'Relaxation Therapy',
      description: 'Gentle, soothing treatments designed to reduce stress, calm the mind, and restore inner peace through aromatherapy and mindful touch.',
      icon: 'ri-heart-pulse-line',
      image: 'https://readdy.ai/api/search-image?query=relaxation-therapy-session-aromatherapy-essential-oils-candles-peaceful-spa-environment-soft-towels-calming-atmosphere-stress-relief-treatment-tranquil-wellness-space-gentle-healing&width=600&height=400&seq=service-relaxation-3&orientation=landscape'
    },
    {
      title: 'Acupuncture',
      description: 'Ancient healing technique using fine needles to stimulate energy flow, relieve pain, and address various health conditions naturally.',
      icon: 'ri-pulse-line',
      image: 'https://readdy.ai/api/search-image?query=acupuncture-treatment-session-fine-needles-professional-practitioner-calm-patient-traditional-chinese-medicine-healing-therapy-peaceful-treatment-room-holistic-wellness-natural-pain-relief&width=600&height=400&seq=service-acupuncture-4&orientation=landscape'
    },
    {
      title: 'Hot Stone Therapy',
      description: 'Heated stones placed on key points of the body to warm and relax muscles, allowing for deeper tissue manipulation and stress relief.',
      icon: 'ri-fire-line',
      image: 'https://readdy.ai/api/search-image?query=hot-stone-massage-therapy-smooth-heated-stones-arranged-on-back-spa-treatment-warm-relaxing-massage-peaceful-wellness-environment-therapeutic-heat-treatment-muscle-relaxation&width=600&height=400&seq=service-hotstone-5&orientation=landscape'
    },
    {
      title: 'Reflexology',
      description: 'Pressure point therapy focusing on feet, hands, and ears to promote healing throughout the body and restore natural energy balance.',
      icon: 'ri-footprint-line',
      image: 'https://readdy.ai/api/search-image?query=reflexology-foot-massage-therapy-pressure-points-professional-therapist-hands-working-on-feet-relaxing-spa-setting-healing-touch-wellness-treatment-natural-health-therapy&width=600&height=400&seq=service-reflexology-6&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-teal-50/30">
      <div className="px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-['Fraunces'] font-semibold text-gray-900 mb-4">
            Our Healing Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover our comprehensive range of therapeutic treatments designed to restore your body, mind, and spirit
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group cursor-pointer">
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 w-14 h-14 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-full">
                  <i className={`${service.icon} text-2xl text-teal-700`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-['Fraunces'] font-semibold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  {service.description}
                </p>
                <a href="#contact" className="inline-flex items-center gap-2 text-teal-700 font-medium hover:gap-3 transition-all cursor-pointer">
                  <span>Book Session</span>
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
